export const subscriptionReducer = (state = {loading: true, subscription: null, errorSubscription: null, resultSubscription: null, resultCancel: null} , action) => {
    switch (action.type) {
        case 'SUBSCRIPTION_LOADING':
            return {
                ...state, loading: true
            }
        case 'SUBSCRIPTION_GET_BY_USER_SUCCESS':
            return {
                ...state,
                loading: false,
                subscription: action.payload
            }
        case 'SUBSCRIPTION_ERROR':
            return {
                ...state,
                loading: false,
                errorSubscription: action.payload
            }
        case 'SUBSCRIPTION_ERROR_RESET':
            return {
                ...state,
                errorSubscription: null
            }
        case 'SUBSCRIPTION_PAYMENT_SUCCESS':
            return {...state, loading: false, resultSubscription: action.payload}
        case 'SUBSCRIPTION_PAYMENT_RESET':
            return {...state, resultSubscription: null}
        case 'SUBSCRIPTION_PAYMENT_ERROR':
            return {...state, loading: false, errorSubscription: action.payload}
        case 'SUBSCRIPTION_CANCEL_SUCCESS':
            return {...state, loading: false, resultCancel: action.payload}
        case 'SUBSCRIPTION_CANCEL_RESET':
            return {...state, resultCancel: null}
        default:
            return state
    }
}

